import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    components: {
        MenuSideNavAuthentication: {
            component: 'CustomAuthentication',
            content: {
                component: 'MenuSideNav',
            },
        },
        MenuSideNav: {
            component: 'Frame',
            type: 'side-nav',
            style: {
                minHeight: '100%',
            },

            sider: {
                fixed: true,
                items: [
                    {
                        component: 'Link',
                        url: '/#/',
                        imageurl: 'logo-menu.png',
                        text: 'logo',
                        className: 'logo-menu flex-layout align-center justify-start',
                        style: {
                            margin: '5px 25px 0',
                            height: '50px',
                            overflow: 'hidden',
                        },
                    },
                    {
                        component: 'Nav',
                        mode: 'inline',
                        theme: 'dark',

                        items: [
                            {
                                type: 'item',
                                key: 'welcome',
                                title: '品真阁',
                                icon: 'home',
                                route: '/welcome',
                            },
                            {
                                type: 'menu',
                                key: 'product',
                                title: '商品管理',
                                icon: 'shopping',
                                privilege: {
                                    path: 'product',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'productInfo',
                                        title: '商品资料中心',
                                        route: '/product/info',
                                        privilege: {
                                            path: 'product.productInfo',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'productLabelRule',
                                        title: '核心标签规则管理',
                                        route: '/product/labelRule',
                                        privilege: {
                                            path: 'product.labelRule',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'productExtendLabelRule',
                                        title: '扩展标签规则管理',
                                        route: '/product/extendLabelRule',
                                        privilege: {
                                            path: 'product.extendLabelRule',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'productSynonym',
                                        title: '同义词管理',
                                        route: '/product/synonym',
                                        privilege: {
                                            path: 'product.synonym',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'goods',
                                        title: '商品经营管理',
                                        route: '/product/goods',
                                        privilege: {
                                            path: 'product.goods',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'pointProductInfo',
                                        title: '积分商品资料中心',
                                        route: '/product/point-info',
                                        privilege: {
                                            path: 'product.pointProductInfo',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'pointGoods',
                                        title: '积分商品经营管理',
                                        route: '/product/point-goods',
                                        privilege: {
                                            path: 'product.pointGoods',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'brand',
                                        title: '商品品牌管理',
                                        route: '/product/brand',
                                        privilege: {
                                            path: 'product.brand',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'category',
                                        title: '展示分类管理',
                                        route: '/product/category',
                                        privilege: {
                                            path: 'product.category',
                                            level: 'full',
                                        },
                                    },
                                    // {
                                    //     type: 'item',
                                    //     key: 'presale-stock',
                                    //     title: '预售库存管理',
                                    //     route: '/product/presale-stock',
                                    //     privilege: {
                                    //         path: 'product.preSalesStock',
                                    //         level: 'full',
                                    //     },
                                    // },
                                    {
                                        type: 'item',
                                        key: 'blackList',
                                        title: '商品黑名单',
                                        route: '/product/black-list',
                                        privilege: {
                                            path: 'product.blackList',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'displayLocation',
                                        title: '商品参数展示配置',
                                        route: '/product/display-location',
                                        privilege: {
                                            path: 'product.displayLocation',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'batchDetailConfig',
                                        title: '移动端详情批量配置',
                                        route: '/product/batchDetailConfig',
                                        privilege: {
                                            path: 'product.batchDetailConfig',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'shelfRule',
                                        title: '上下架规则',
                                        route: '/product/shelfRule',
                                        privilege: {
                                            path: 'product.shelfRule',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'trade',
                                title: '交易管理',
                                icon: 'account-book',
                                privilege: {
                                    path: 'trade',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'order',
                                        title: '销售订单管理',
                                        route: '/trade/order',
                                        privilege: {
                                            path: 'trade.order',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'orderNew',
                                        title: '新销售订单管理',
                                        route: '/trade/orderNew',
                                        privilege: {
                                            path: 'trade.orderNew',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'changePrice',
                                        title: '订单改价管理',
                                        route: '/trade/changePrice',
                                        privilege: {
                                            path: 'trade.changePrice',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'changeSKu',
                                        title: '订单置换skn',
                                        route: '/trade/changeSKu',
                                        privilege: {
                                            path: 'trade.changeSkn',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'orderPrint',
                                        title: '订单打印',
                                        route: '/trade/orderPrint',
                                        privilege: {
                                            path: 'trade.orderPrint',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'aftersale',
                                        title: '售后管理',
                                        route: '/trade/aftersale',
                                        privilege: {
                                            path: 'trade.aftersale',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'refund',
                                        title: '退款管理',
                                        route: '/trade/refund',
                                        privilege: {
                                            path: 'trade.refund',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'pointsOrder',
                                        title: '积分订单管理',
                                        route: '/trade/pointsOrder',
                                        privilege: {
                                            path: 'trade.pointsOrder',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'appointment',
                                        title: '预约看货记录',
                                        route: '/trade/appointment',
                                        privilege: {
                                            path: 'trade.appointment',
                                            level: 'full',
                                        },
                                    },
                                    // {
                                    //     type: 'item',
                                    //     key: 'presellOrder',
                                    //     title: '预售订单批次管理',
                                    //     route: '/trade/presellOrder',
                                    //     privilege: {
                                    //         path: 'trade.presellOrder',
                                    //         level: 'full',
                                    //     },
                                    // },
                                    {
                                        type: 'item',
                                        key: 'shippingOrder',
                                        title: '发货单管理',
                                        route: '/trade/shippingOrder',
                                        privilege: {
                                            path: 'trade.shippingOrder',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'deliverOrder',
                                        title: '快递面单打印',
                                        route: '/trade/deliveryOrder',
                                        privilege: {
                                            path: 'trade.shippingOrder',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'user',
                                title: '用户管理',
                                icon: 'user',
                                privilege: {
                                    path: 'user',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'member',
                                        title: '会员管理',
                                        route: '/user/member',
                                        privilege: {
                                            path: 'user.member',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'feedback',
                                        title: '意见反馈',
                                        route: '/user/feedback',
                                        privilege: {
                                            path: 'user.feedback',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'review',
                                        title: '会员评论管理',
                                        route: '/user/review',
                                        privilege: {
                                            path: 'user.review',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'filterWord',
                                        title: '敏感词管理',
                                        route: '/user/filterWord',
                                        privilege: {
                                            path: 'user.filterWord',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'content',
                                title: '内容管理',
                                icon: 'container',
                                privilege: {
                                    path: 'content',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'reason',
                                        title: '原因管理',
                                        route: '/content/reason',
                                        privilege: {
                                            path: 'content.reason',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'articleCategroy',
                                        title: '文章栏目管理',
                                        route: '/content/articleCategroy',
                                        privilege: {
                                            path: 'content.articleCategroy',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'article',
                                        title: '文章管理',
                                        route: '/content/article',
                                        privilege: {
                                            path: 'content.article',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'sunbathingOrder',
                                        title: '晒单管理',
                                        route: '/content/sunbathingOrder',
                                        privilege: {
                                            path: 'content.sunbathingOrder',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'system',
                                title: '系统管理',
                                icon: 'setting',
                                privilege: {
                                    path: 'system',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'securityUser',
                                        title: '系统用户管理',
                                        route: '/system/securityUser',
                                        privilege: {
                                            path: 'system.securityUser',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'security',
                                        title: '权限设置',
                                        route: '/system/security',
                                        privilege: {
                                            path: 'system.security',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'express',
                                        title: '顺丰快递配置',
                                        route: '/system/express',
                                        privilege: {
                                            path: 'system.express',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'sms',
                                        title: '短信配置',
                                        route: '/system/sms',
                                        privilege: {
                                            path: 'system.sms',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'region',
                                        title: '地区管理',
                                        route: '/system/region',
                                        privilege: {
                                            path: 'system.region',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'delivery',
                                        title: '收购配送管理',
                                        route: '/system/delivery',
                                        privilege: {
                                            path: 'system.delivery',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'paymentContent',
                                        title: '支付方式内容管理',
                                        route: '/system/paymentContent',
                                        privilege: {
                                            path: 'system.paymentContent',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'paymentMode',
                                        title: '支付方式管理',
                                        route: '/system/paymentMode',
                                        privilege: {
                                            path: 'system.paymentMode',
                                            level: 'full',
                                        },
                                    },
                                    // {
                                    //     type: 'item',
                                    //     key: 'noticeTemplate',
                                    //     title: '站内信模板配置',
                                    //     route: '/system/noticeTemplate',
                                    //     privilege: {
                                    //         path: 'system.noticeTemplate',
                                    //         level: 'full',
                                    //     },
                                    // },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'design',
                                title: '页面配置管理',
                                icon: 'eye',
                                privilege: {
                                    path: 'design',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'page',
                                        title: '小程序页面管理',
                                        route: '/design/page',
                                        privilege: {
                                            path: 'design.page',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'template',
                                        title: '小程序模板管理',
                                        route: '/design/template',
                                        privilege: {
                                            path: 'design.template',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'structure',
                                        title: '网站结构管理',
                                        route: '/design/structure',
                                        privilege: {
                                            path: 'design.structure',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'hotWords',
                                        title: '热词管理',
                                        route: '/design/hotWords',
                                        privilege: {
                                            path: 'design.hotWords',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'sidebarMenu',
                                        title: '侧边导航tab',
                                        route: '/design/sidebarMenu',
                                        privilege: {
                                            path: 'design.sidebarMenu',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'floatingLayer',
                                        title: '首页浮层管理',
                                        route: '/design/floatingLayer',
                                        privilege: {
                                            path: 'design.floatingLayer',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'lotteryConfig',
                                        title: '甄币抽奖链接设置',
                                        route: '/design/lotteryConfig',
                                        privilege: {
                                            path: 'design.lotteryConfig',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'store',
                                title: '门店管理',
                                icon: 'shop',
                                privilege: {
                                    path: 'store',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'stores',
                                        title: '门店信息管理',
                                        route: '/store/stores',
                                        privilege: {
                                            path: 'store.stores',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'reports',
                                title: '报表管理',
                                icon: 'file-excel',
                                privilege: {
                                    path: 'reports',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'import',
                                        title: '批量导入管理',
                                        route: '/import',
                                        privilege: {
                                            path: 'reports.import',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'export',
                                        title: '报表导出管理',
                                        route: '/export',
                                        privilege: {
                                            path: 'reports.export',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                            {
                                type: 'menu',
                                key: 'live',
                                title: '直播管理',
                                icon: 'audio',
                                privilege: {
                                    path: 'live',
                                    level: 'full',
                                },
                                items: [
                                    {
                                        type: 'item',
                                        key: 'liveRooms',
                                        title: '直播间管理',
                                        route: '/live-room',
                                        privilege: {
                                            path: 'live.room',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'liveRoomsList',
                                        title: '直播列表管理',
                                        route: '/live-list',
                                        privilege: {
                                            path: 'live.list',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'liveProducts',
                                        title: '直播商品管理',
                                        route: '/live-product',
                                        privilege: {
                                            path: 'live.product',
                                            level: 'full',
                                        },
                                    },
                                    {
                                        type: 'item',
                                        key: 'liveWechatData',
                                        title: '微信直播间数据',
                                        route: '/live-wechatData',
                                        privilege: {
                                            path: 'live.liveWechatData',
                                            level: 'full',
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            header: {
                items: [
                    {
                        component: 'UserMenu',
                        flex: '0 0 auto',
                    },
                ],
            },
            content: {
                items: [
                    {
                        component: 'Viewport',
                    },
                ],
            },
            footer: {
                items: [
                    {
                        component: 'Text',
                        text: 'Powered by Co-Mall',
                    },
                ],
            },
        },
        UserMenu: {
            component: 'Nav',
            className: 'nav-header',
            mode: 'horizontal',
            theme: 'light',
            items: [
                {
                    type: 'menu',
                    key: 'user',
                    component: {
                        name: 'ProfileMini',
                    },
                    items: [
                        {
                            type: 'item',
                            key: 'logout',
                            component: {
                                name: 'Logout',
                            },
                        },
                        // {
                        //     type: 'item',
                        //     key: 'modifyPwd',
                        //     component: {
                        //         name: 'UserModifyPwd',
                        //     },
                        // },
                    ],
                },
            ],
        },
        UserModifyPwd: {
            component: 'ModifyPwdModalForm',
            title: '修改密码',
            mask: false,
            maskClosable: true,
            triggerComponent: {
                text: '修改密码',
            },
        },
    },
};
